<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addDetail" style="margin-top: 20px">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <p style="color: red">请填写100份所需的原材料数量</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="产品编码" prop="OP_CODE"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="含量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OP_RATE" @input.native="OpRate($event, scope.row)"
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteRecord(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="20">
        <p style="color: red">*删除后请务必点击提交才能生效</p>
      </el-col>
      <el-col :span="4">
        <el-button @click="submitAdd" style="margin-top: 20px; float: right">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { productionDetailFun1, addDetailFun1 } from 'api/productionSet';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      searchForm: {},
      getProductArr: [],
    };
  },
  created() {
    this.msg = '我在这里';
    console.log(this);
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryData();
    this.getProductArr = JSON.parse(sessionStorage.getItem('productArr'));
  },
  methods: {
    queryData() {
      const params = {
        PPL_ID: sessionStorage.getItem('PPL_ID'),
      };
      productionDetailFun1(params).then((result) => {
        if (this.getProductArr) {
          const arr = result.concat(this.getProductArr);
          const res = new Map();
          // eslint-disable-next-line no-shadow
          this.tableData = arr.filter((arr) => !res.has(arr.OP_CODE) && res.set(arr.OP_CODE, 1));
        } else {
          this.tableData = result;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData(e - 1);
    },
    OpRate(e, row) {
      row.OP_RATE = e.target.value;
    },
    addDetail() {
      this.$router.push({ name: 'addIngredients' });
      sessionStorage.setItem('addedProductArr', JSON.stringify(this.tableData));
    },
    submitAdd() {
      let flag = true;
      this.tableData.map((item) => {
        if (item.OP_RATE == '') {
          console.log('我进来了');
          this.$message.show({ text: '数值不能为空', type: 'error' });
          flag = false;
          return false;
        }
      });
      let submitArr = [];
      submitArr = this.tableData.map((item) => ({ PRODUCT_CODE: item.OP_CODE, OP_RATE: item.OP_RATE }));
      const params = {
        PRODUCT_ARRAY: submitArr,
        PPL_ID: sessionStorage.getItem('PPL_ID'),
      };
      if (flag) {
        addDetailFun1(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    deleteRecord(row) {
      const tmpArr = this.tableData.filter((item) => item.OP_CODE !== row.OP_CODE);
      this.tableData = tmpArr;
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/productionProcessing/ingredientsDetail.vue